(() => {
  if(document.body.dataset.globalTextCustom!=='true')return;
  const selector='h1,h2,h3,h4,h5,h6,p,blockquote,button,a,label,legend,small,dt,dd';
  const original=new WeakMap();let frame=0;
  function apply(){
    frame=0;const elements=[...document.querySelectorAll(selector)];
    elements.forEach(e=>{if(!original.has(e))original.set(e,[e.style.getPropertyValue('font-size'),e.style.getPropertyPriority('font-size')]);const [value,priority]=original.get(e);if(value)e.style.setProperty('font-size',value,priority);else e.style.removeProperty('font-size');});
    const sizes=elements.map(e=>[e,getComputedStyle(e).fontSize]);
    sizes.forEach(([e,size])=>{e.style.fontSize='calc('+size+' * var(--global-text-scale,1)'+(/^H[1-6]$/.test(e.tagName)?' * var(--global-heading-scale,1)':'')+')';});
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(apply);}
  apply();window.addEventListener('resize',schedule);document.addEventListener('shopify:section:load',schedule);
})();
